export default __webpack_public_path__ + "static/media/youtube.3c776cd6.svg";